import {
  setWASelfProvisionForm,
  resetWASelfProvisionForm,
  validateSelfProvisionTokenIsValid,
} from '../actions/waitingArea.js';
import { redirectToInternalLink } from './redirector';

import { displayGlobalMessage } from '../actions/globalMessage.js';
import { updateShowRegisterUserWithWA } from '../actions/modal';
import { processAuthorization, getUrlParameter } from './authorizator';
export let validateSelfProvisionLink = (res, dispatcher, doNotRedirect) => {
  window.showingOverLay = true;
  validateSelfProvisionWorkFlow(dispatcher).then(({ isTokenValid, selfProvisionResponse }) => {
    if (isTokenValid) {
      //valid selfProvision
      dispatcher(setWASelfProvisionForm(selfProvisionResponse));
    } else {
      //means the self provision is not valid
      dispatcher(resetWASelfProvisionForm());
    }

    processAuthorization(res, dispatcher, doNotRedirect, isTokenValid, selfProvisionResponse);
  });
};

export let validateSelfProvisionResponseForExistingUser = (
  dispatcher,
  loggedInPersonEmail,
  isTokenValid,
  selfProvisionResponse
) => {
  let isSelfProvisionLinkValid = false;

  if (isTokenValid && selfProvisionResponse.isLinkValid) {
    //So if the link is valid and the response contains an email, but the login person is someone else
    if (selfProvisionResponse.email.toLowerCase() == loggedInPersonEmail.toLowerCase()) {
      isSelfProvisionLinkValid = true;
    } else {
      dispatcher(
        displayGlobalMessage({
          text: APP.LANGUAGE.SelfProvisionCreateWA.InvalidToken,
          visible: true,
          messageType: 'Bad',
        })
      );
    }
  }

  return isSelfProvisionLinkValid;
};

export let selfProvisionModelForExistingUser = (dispatcher) => {
  setTimeout(() => {
    //this is being done to be sure that the login in form has been un mounted
    //this was causing problem in validation library. as it still had the old controls mounted
    dispatcher(updateShowRegisterUserWithWA(true));
  }, 200);
};

let validateSelfProvisionWorkFlow = (dispatcher) => {
  return new Promise((resolve) => {
    //This function determines whether to show the Self provision Modal Dialogue or not
    const selfProvisionCreateForm = window.getState().waitingAreaReducer.selfProvisionCreateForm;
    if (selfProvisionCreateForm.email && selfProvisionCreateForm.email != '') {
      //if the user has any values in the form object
      return resolve({ isTokenValid: true, selfProvisionResponse: selfProvisionCreateForm });
    }
    const cb = (result, response) => {
      if (result) {
        //means true
        return resolve({ isTokenValid: true, selfProvisionResponse: response });
      }
      return resolve({ isTokenValid: false, selfProvisionResponse: response });
    };

    var selfProvisionWA = getUrlParameter('selfProvisionWA');

    if (selfProvisionWA) {
      dispatcher(validateSelfProvisionTokenIsValid(selfProvisionWA, cb));
    } else {
      return resolve({ isTokenValid: false, selfProvisionResponse: 'Not valid for Self Provision WorkFlow' });
    }
  });
};

export let validateSelfProvisionLinkOnSessionTimeOut = (dispatcher) => {
  validateSelfProvisionWorkFlow(dispatcher).then(({ isTokenValid, selfProvisionResponse }) => {
    if (isTokenValid) {
      //valid selfProvision
      dispatcher(setWASelfProvisionForm(selfProvisionResponse));
      window.$('#overlay').hide();
      return;
    } else {
      //means the self provision is not valid
      dispatcher(resetWASelfProvisionForm());
      redirectToInternalLink('/login');
      // redirect to login view
    }
  });
};

export let getWaitingAreaNameToShortURL = (waName) => {
  let urlFormatRegex = /^([a-zA-Z\d])(([\/\-_]){0,}[a-zA-Z\d]([\/\-_]){0,})*$/;
  var shortUrl = '';
  waName = waName.trim();

  if (waName.length > 2) {
    waName
      .trim()
      .split('')
      .forEach((char) => {
        if (char == ' ' && (urlFormatRegex.test(shortUrl + '-') || shortUrl.length == 1 || shortUrl.length == 2)) {
          shortUrl += '-';
        } else if (urlFormatRegex.test(shortUrl + char)) {
          shortUrl += char;
        }
      });
    shortUrl = shortUrl.replace(/--/g, '-');
    shortUrl = shortUrl.toLowerCase();
  }
  return shortUrl;
};

export function trimSlashAtTheEnd(waitingAreaUrl) {
  waitingAreaUrl =
    waitingAreaUrl.lastIndexOf('/') == waitingAreaUrl.length - 1
      ? waitingAreaUrl.substring(0, waitingAreaUrl.length - 1)
      : waitingAreaUrl;

  return waitingAreaUrl;
}
